import { useRef, useState } from 'react';
import { workoutTypes } from '../static';
import Title from '../../../../components/dialog/title';
import Detail from './detail';

const CreateLog = ({
  dialogRef,
  closeDialog,
  refreshWorkoutTracker,
  selectedDate,
  preference,
  user,
}) => {
  const detailDialogRef = useRef(null);

  const [selectedType, setSelectedType] = useState(null);
  const [title, setTitle] = useState('Add Workout Record');

  const handleSelectType = (type) => {
    setSelectedType(type);
    setTitle(type.name);
  };

  const closeDetailDialog = () => {
    setSelectedType(null);
    setTitle('Add Workout Record');
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='p-4 w-full h-full max-w-lg max-h-full bg-primary'
      onCancel={closeDialog}
    >
      {selectedType ? (
        <Detail
          type={selectedType}
          dialogRef={detailDialogRef}
          closeDialog={closeDetailDialog}
          refreshWorkoutTracker={refreshWorkoutTracker}
          selectedDate={selectedDate}
          preference={preference}
          user={user}
        />
      ) : (
        <>
          <Title
            title={title}
            onClick={closeDialog}
            color='white'
          />
          <div className='text-white space-y-4'>
            {workoutTypes.map((type) => (
              <button
                key={type.type}
                className='w-full p-4 text-left bg-secondary rounded-full flex items-center justify-between'
                onClick={() => handleSelectType(type)}
              >
                <div className='font-semibold flex items-center gap-3'>
                  <span className='text-xl'>{type.icon}</span>
                  <span>{type.name}</span>
                </div>
                <span className='text-2xl opacity-40'>›</span>
              </button>
            ))}
          </div>
        </>
      )}
    </dialog>
  );
};

export default CreateLog;
